import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useEffect, useMemo, useState } from 'react';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { changeIframeOnClick } from '../../../../../../../helper/Helpers';

function BottomBar_Yenir({ item, activeThemePageId }) {
  return <img src={item?.placeholderImage} className={` w-full `} />;
}
export default BottomBar_Yenir;
